import React from 'react';

import { Box } from '@mui/material';
import { RotatingLines } from 'react-loader-spinner';

import { lightPalette } from '@app/theme';

import type { SmallInlineLoadingSpinnerType } from './SmallInlineLoadingSpinner.types';

export const SmallInlineLoadingSpinner: React.FC<
  SmallInlineLoadingSpinnerType
> = ({
  size = '15',
  isLoading,
  sx,
  dataTest = 'small_inline_loading_spinner',
}) => {
  return (
    <Box sx={sx} data-testid={dataTest}>
      <RotatingLines
        height={size}
        width={size}
        strokeColor={lightPalette.text.muted}
        visible={isLoading}
      />
    </Box>
  );
};
